<template>
  <v-layout align-center>
    <v-flex
      v-if="
        bookingForm.booking.state == null ||
          bookingForm.booking.state == 'booked'
      "
      px-1
      md5
      lg5
      xl5
      sm5
      py-1
      shrink
    >
      <SelectableDriverInput
        v-model="bookingForm.booking.preassigned_driver"
        :error="bookingForm.errors.preassigned_driver"
        label="Preassign Trip"
        :booking-form="bookingForm"
      />
    </v-flex>
    <v-flex mt-5>
      <v-layout>
        <v-flex
          shrink
          px-1
        >
          <IconToggle
              class="mr-1"
            v-model="bookingForm.booking.manual_dispatch"
            :disabled="bookingIsCompletedOrCancelled"
            text="Manual"
            @input="
              (input) => {
                bookingForm.booking.manual_dispatch = input;
              }
            "
          />
          <IconToggle
              class="mr-1"
            v-model="bookingForm.booking.offer_booking_publically"
            :disabled="bookingIsCompletedOrCancelled"
            text="BID"
            @input="
              (input) => {
                bookingForm.booking.offer_booking_publically = input;
              }
            "
          />
          <IconToggle
              class="mr-1"
            v-model="bookingForm.booking.priority"
            :disabled="bookingIsCompletedOrCancelled"
            text="Priority"
            @input="
              (input) => {
                bookingForm.booking.priority = input;
              }
            "
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import SelectableDriverInput from "@/components/widget/input/SelectableDriverInputV2.vue";
import IconToggle from "@/components/widget/input/IconToggleSquareV2.vue";

export default {
  name: "BookingDispatchInput",
  components: {
    IconToggle,
    SelectableDriverInput,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    preassignedDriverError: {
      cache: false,
      get: function () {
        return this.bookingForm.errors.preassigned_driver;
      },
    },
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    },
  },
  methods: {
    updateFinalCosts: function () {
      this.$emit("updateFinalCosts", null);
    },
    changePaymentTypeToCard: function (card) {
      console.log("CHANGE PAYMENT TYPE TO CARD");
      this.bookingForm.changePaymentType("card", card);
    },
    changePaymentType: function (paymentType) {
      this.bookingForm.changePaymentType(paymentType, null);
    },
    changePromocode: function (promocode) {
      this.bookingForm.changePromocode(promocode);
    },
    changeAdditionalCharge: function (additionalCharge) {
      this.bookingForm.additional_charge = additionalCharge;
      this.bookingForm.getCostEstimate();
    },
    changeFinalCost: function (finalCost) {
      this.bookingForm.booking.final_cost = finalCost;
      this.bookingForm.booking.fixedCostType =
        this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changeFinalCostDriver: function (finalCostDriver) {
      this.bookingForm.booking.final_cost_driver = finalCostDriver;
      this.bookingForm.booking.fixedCostDriverType =
        this.bookingForm.FIXED_COST_DISPATCHER();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.change-cost-panel {
  background-color: #e3f2fd;
}
</style>
